import React from 'react';
export var FlexFactor = function FlexFactor(_ref) {
  var _ref$Tag = _ref.Tag,
    Tag = _ref$Tag === void 0 ? 'div' : _ref$Tag,
    _ref$basis = _ref.basis,
    basis = _ref$basis === void 0 ? 'auto' : _ref$basis,
    children = _ref.children,
    className = _ref.className,
    grow = _ref.grow,
    shrink = _ref.shrink;
  return /*#__PURE__*/React.createElement(Tag, {
    className: className,
    style: {
      flexBasis: basis,
      flexGrow: grow,
      flexShrink: shrink
    },
    "data-t-id": "components-FlexFactor"
  }, children);
};